import React from "react";
import { FileText, Download, ExternalLink } from "lucide-react";
import { useT } from "@/i18n";

const HREFS = [
  "https://www.daytonsuperior.com/docs/default-source/tech-data-sheets/top-cast.pdf?sfvrsn=12ded560_37",
  "https://www.daytonsuperior.com/docs/default-source/brochures/top-cast-architectural-brochure.pdf?sfvrsn=8a90b260_26",
  "https://www.daytonsuperior.com/docs/default-source/application-guides/top-cast-user-guide.pdf",
];

const Resources = () => {
  const { t } = useT();
  return (
    <section id="resources" data-testid="resources-section" className="py-24 sm:py-32 bg-[#ece8df] border-y border-black/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16 items-end">
          <div className="md:col-span-7">
            <div className="overline mb-6">{t.resources.overline}</div>
            <h2 className="font-display text-4xl sm:text-6xl tracking-tight leading-[1.02]">
              {t.resources.h}<br />{t.resources.h2}
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-zinc-700 leading-relaxed">{t.resources.sub}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-black/10 border border-black/10">
          {t.resources.docs.map((d, i) => (
            <a
              key={i}
              href={HREFS[i]}
              target="_blank"
              rel="noreferrer"
              data-testid={`resource-pdf-${i}`}
              className="group relative bg-[#faf7f2] p-8 sm:p-10 hover:bg-white transition-colors duration-500 flex flex-col"
            >
              <div className="flex items-start justify-between mb-10">
                <div className="w-12 h-12 flex items-center justify-center border border-[#ea7a1f] bg-[#ea7a1f]/10">
                  <FileText className="w-5 h-5 text-[#ea7a1f]" strokeWidth={1.5} />
                </div>
                <span className="overline">{d.badge}</span>
              </div>
              <div className="text-xs tracking-[0.25em] uppercase text-zinc-500 mb-2">{d.sub}</div>
              <h3 className="font-display text-2xl tracking-tight leading-snug mb-4">{d.title}</h3>
              <p className="text-zinc-600 leading-relaxed mb-8">{d.desc}</p>
              <div className="mt-auto inline-flex items-center gap-2 text-[#ea7a1f] font-semibold copper-line w-fit">
                {t.resources.download} <Download className="w-4 h-4" />
              </div>
              <ExternalLink className="absolute top-8 right-8 sm:top-10 sm:right-10 w-4 h-4 text-zinc-400 opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="absolute bottom-0 left-0 h-px w-0 bg-[#ea7a1f] group-hover:w-full transition-all duration-700" />
            </a>
          ))}
        </div>

        <div className="mt-10 text-xs text-zinc-500 tracking-wide">{t.resources.footer}</div>
      </div>
    </section>
  );
};

export default Resources;
